// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1bPnl","inputWrap":"Table_inputWrap__2PD6B","col":"Table_col__3RuuG","bmiTooltip":"Table_bmiTooltip__1q7hV"};